
    <button type="button" class="btn btn-primary btn-sm" (click)="showDetails()" style="font-size: 12px;width: 40px;" data-toggle="tooltip" title="See Details"> 
        <i class="fas fa-info-circle"></i> 
    </button>


